import { render, staticRenderFns } from "./FDCreate.vue?vue&type=template&id=34690c60&"
import script from "./FDCreate.vue?vue&type=script&lang=js&"
export * from "./FDCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports